import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { AIMessageStyles } from './style';
import './style.scss';
import { Box, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
export function AIMessage({ content, timestamp, sources, onReferenceClick }) {
    const theme = useTheme();
    const isMdScreen = useMediaQuery('(min-width:900px) and (max-width:1300px)');
    const handleCopyClick = () => {
        if (typeof content === 'string') {
            navigator.clipboard
                .writeText(content)
                .then(() => { })
                .catch((err) => { });
        }
        else {
        }
    };
    const renderableContent = useMemo(() => {
        const referencesMarkdown = sources
            ?.map((source, index) => {
            return `[🔗 ${source.page_number}](#ref-${index})`;
        })
            .join(' ');
        return `${content}\n\n---\n**References:** ${referencesMarkdown}`;
    }, [content, sources]);
    return (_jsx(Stack, { style: { margin: '12px 0px' }, sx: AIMessageStyles.root, children: _jsxs(Stack, { sx: AIMessageStyles.messageContainer, style: {
                backgroundColor: theme.palette.background.neutral,
                maxWidth: isMdScreen ? '100%' : '80%'
            }, children: [typeof content === 'string' ? (_jsx(Typography, { sx: {
                        ...AIMessageStyles.content,
                        color: theme.palette.text.primary
                    }, children: _jsx(ReactMarkdown, { className: 'reactMarkDown', remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], components: {
                            a: ({ node, ...props }) => {
                                const index = Number((props.href || '').replace('#ref-', ''));
                                const source = sources?.[index];
                                return (_jsx(IconButton, { onClick: () => source && onReferenceClick?.(source, sources), sx: {
                                        backgroundColor: theme.palette.secondary.main,
                                        color: '#FFFFFF',
                                        borderRadius: '50%',
                                        width: 28,
                                        height: 28,
                                        fontSize: 12,
                                        fontWeight: 'bold',
                                        '&:hover': {
                                            backgroundColor: theme.palette.secondary.dark,
                                            cursor: 'pointer'
                                        }
                                    }, children: source?.page_number }));
                            }
                        }, children: renderableContent }) })) : (content), typeof content !== 'string' && sources && sources?.length > 0 && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(Typography, { variant: 'body2', fontWeight: 'bold', color: theme.palette.text.primary, children: "References:" }), _jsx(Stack, { direction: 'row', spacing: 1, mt: 1, children: sources &&
                                sources.map((source, index) => (_jsx(IconButton, { onClick: () => source && onReferenceClick?.(source, sources), sx: {
                                        backgroundColor: theme.palette.secondary.main,
                                        color: '#FFFFFF',
                                        borderRadius: '50%',
                                        width: 28,
                                        height: 28,
                                        fontSize: 12,
                                        fontWeight: 'bold',
                                        '&:hover': {
                                            backgroundColor: theme.palette.secondary.dark,
                                            cursor: 'pointer'
                                        }
                                    }, children: source?.page_number }, index))) })] })), _jsx(Typography, { variant: 'caption', color: theme.palette.text.secondary, sx: AIMessageStyles.content, children: timestamp })] }) }));
}
{
    /* <Stack horizontal tokens={{ childrenGap: 4 }} className={styles.actionButtons}>
            <Button
              size='small'
              icon={<Refresh color={tokens.colorBrandBackground} />}
              appearance='transparent'
            />
            <Button
              size='small'
              icon={<Copy color={tokens.colorBrandBackground} />}
              appearance='transparent'
              onClick={handleCopyClick}
            />
          </Stack> */
}
